const config = {
	api: 'https://csonews.ust.hk/eta/api',
	appPath: '/eta/app',
	loginTimeout: 18000000,
	googleMapsSearchUrl: 'https://www.google.com/maps/search/?api=1&query=',
	// Lung Wai live shuttle tracker; the type decides which fleet is shown (staff | student).
	gpsTrackerUrl: 'https://ustgps.ibasezero.com/?type=',
	// GA4 measurement id (G-XXXXXXXXXX). Blank disables analytics entirely.
	gaMeasurementId: 'G-B01NTWREN3'
};

export default config;
